document.addEventListener('DOMContentLoaded', () => {
  
  // --- 1. Sidebar Category Switching ---
  const menuBtns = document.querySelectorAll('.cfaq-menu-btn');
  const categoryGroups = document.querySelectorAll('.cfaq-category-group');

  if (menuBtns.length > 0) {
    menuBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        // Remove active state from all buttons and groups
        menuBtns.forEach(b => b.classList.remove('active'));
        categoryGroups.forEach(g => g.classList.remove('active'));

        // Add active state to clicked button
        btn.classList.add('active');

        // Find the matching group and show it
        const targetId = 'group-' + btn.getAttribute('data-target');
        const targetGroup = document.getElementById(targetId);
        
        if (targetGroup) {
          targetGroup.classList.add('active');
        }
      });
    });
  }

  // --- 2. Accordion Toggles ---
  const accordions = document.querySelectorAll('.cfaq-accordion-trigger');

  if (accordions.length > 0) {
    accordions.forEach(acc => {
      acc.addEventListener('click', () => {
        const isExpanded = acc.getAttribute('aria-expanded') === 'true';
        
        // Optional: Close all other accordions when one is opened (uncomment below if desired)
        // accordions.forEach(a => a.setAttribute('aria-expanded', 'false'));
        
        // Toggle the clicked accordion
        acc.setAttribute('aria-expanded', !isExpanded);
      });
    });
  }
});
